import { TypeChecker } from '@attain-apps/type-guards'

/**
 * The BCH Defend to Spend source document bundle.
 */
export interface Files {
  readonly cashDraw: Uint8Array
  readonly justifications: Uint8Array
  readonly subaccountSummary: Uint8Array
}
export namespace Files {
  const isBytes = TypeChecker.Factory.instance(Uint8Array)

  export const isFiles: TypeChecker<Files> = TypeChecker.Factory.object({
    cashDraw: isBytes,
    justifications: isBytes,
    subaccountSummary: isBytes,
  })
}
